<input type="radio" class="cm-radio" [name]="name" [id]="id" [checked]="checked" [disabled]="disabled">
<label class="cm-radio-label" [for]="id">
  <ng-content></ng-content>
</label>
